import React from "react";
import "./organisationCard.css";
import { Organisation } from "../../features/organisation/organisationTypes";
import { reportCardLinkClicked } from "../../services/utmService";
import { ColumnFlexBox, RowFlexBox } from "../common/FlexBoxes";
import { useTheme } from "@emotion/react";
import { Icon, Link } from "@tal-gel/components-v2";
import styled from "@emotion/styled";

interface propsFromComponent {
  item: Organisation;
}

type Props = propsFromComponent;

const StyledColumnFlexBox = styled(ColumnFlexBox)`
  align-items: flex-start;
  gap: 4px;
  margin-bottom: 16px;
`;

const StyledRowFlexBox = styled(RowFlexBox)<{ visible: boolean }>`
  align-items: center;
  gap: 6px;
  display: ${({ visible }) => (visible ? "flex" : "none")};
`;

const StyledIcon = styled(Icon)`
  padding-top: 1px;
`;

const StyledLink = styled(Link)`
  font-size: 15px;
`;

const OrganisationContactInfo: React.FC<Props> = ({ item }) => {
  const phoneLink = "tel:" + item.phoneNumber;
  const theme = useTheme();

  return (
    <StyledColumnFlexBox>
      <StyledRowFlexBox visible={!!item.website}>
        <StyledIcon name="Globe" fill={theme.tokens.global.themeColorIconDefault} width="18" />
        <StyledLink
          href={item.website}
          target="_blank"
          onClick={() => {
            reportCardLinkClicked(item.website, item.externalName);
          }}
        >
          {item.externalName} Website
        </StyledLink>
      </StyledRowFlexBox>
      <StyledRowFlexBox visible={!!item.phoneNumber}>
        <StyledIcon name="Phone" fill={theme.tokens.global.themeColorIconDefault} width="18" />
        <StyledLink href={phoneLink} onClick={() => reportCardLinkClicked(phoneLink, item.externalName)}>
          {item.phoneNumber}
        </StyledLink>
      </StyledRowFlexBox>
    </StyledColumnFlexBox>
  );
};

export default OrganisationContactInfo;
